import { graphHooks } from '@tunasong/graph-lib/react'
import { SystemTags } from '@tunasong/models'
import type { RenderMenuItemProps } from '@tunasong/plugin-lib'
import { ListItemText, MenuCheckboxItem } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './template-action.module.css'

export interface TemplateMenuItemProps extends Pick<RenderMenuItemProps, 'element'> {}

/**
 * "Use as template": a `menuitemcheckbox`, so its state is announced (WCAG 4.1.2). Toggling leaves the menu open,
 * Base UI's default for checkbox items. Must be rendered inside the canonical `<Menu>`.
 */
export const TemplateMenuItem: FC<TemplateMenuItemProps> = props => {
  const { element } = props

  const { hasTag, addTag, removeTag } = graphHooks.useTags(element)

  const handleCheckedChange = (checked: boolean) => {
    if (checked) {
      addTag(SystemTags.Template)
      return
    }
    removeTag(SystemTags.Template)
  }

  return (
    <MenuCheckboxItem
      className={styles.item}
      checked={hasTag(SystemTags.Template)}
      onCheckedChange={handleCheckedChange}
    >
      <ListItemText primary="Use as template" />
    </MenuCheckboxItem>
  )
}

export default TemplateMenuItem
